import { FormattedMessage } from 'react-intl';

import { TIdVerificationRequirement } from '../../fundingRequirements.types';
import { RequirementItem } from '../RequirementItem/RequirementItem';

export const IdVerification = ({ status }: TIdVerificationRequirement) => {
    return (
        <RequirementItem
            title={
                <FormattedMessage
                    id="_.funding_requirements_v2.type.id_verification"
                    defaultMessage="Verify your identity"
                />
            }
            estimatedTime={
                <FormattedMessage
                    id="_.funding_requirements_v2.time.5_min"
                    defaultMessage="~ 5 Min."
                />
            }
            status={status}
        />
    );
};
